var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_384_2139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4937 53.9896L43 57.5401L45.5063 53.9896C45.6107 53.8483 55.814 39.431 59.0267 35.8313C62.5589 31.8876 64.5 26.7951 64.5 21.5C64.5 9.65043 54.8557 0 43 0C31.1443 0 21.5 9.64429 21.5 21.5C21.5 26.8013 23.4411 31.8937 26.9794 35.8374C30.1983 39.431 40.3893 53.8483 40.4937 53.9896ZM43 6.14286C51.471 6.14286 58.3571 13.0351 58.3571 21.5C58.3571 25.284 56.9689 28.9206 54.4441 31.7401C52.0239 34.4491 46.3233 42.2936 43 46.9253C39.6829 42.2936 33.9823 34.4491 31.5559 31.7401C29.0373 28.9267 27.6429 25.2901 27.6429 21.5C27.6429 13.0351 34.529 6.14286 43 6.14286ZM43 30.7143C48.0801 30.7143 52.2143 26.5801 52.2143 21.5C52.2143 16.4199 48.0801 12.2857 43 12.2857C37.9199 12.2857 33.7857 16.4199 33.7857 21.5C33.7857 26.5801 37.9199 30.7143 43 30.7143ZM43 18.4286C44.6893 18.4286 46.0714 19.8046 46.0714 21.5C46.0714 23.1954 44.6893 24.5714 43 24.5714C41.3107 24.5714 39.9286 23.1954 39.9286 21.5C39.9286 19.8046 41.3107 18.4286 43 18.4286ZM86 6.24114V73.7327L59.125 86L30.7143 73.7143L0 85.9386V18.6374L16.1496 12.1199C15.6704 14.1531 15.3571 16.2479 15.3571 18.4286C15.3571 18.6374 15.4063 18.834 15.4124 19.0429L6.14286 22.7839V76.884L24.5714 69.5494V39.5477C26.3037 41.7899 28.552 44.8367 30.7143 47.816V67.1046L30.8126 67.0677L33.153 68.0813L55.2857 77.6457V47.8283C57.491 44.7937 59.7209 41.7653 61.4286 39.56V78.1986L79.8571 69.7829V15.7994L70.4954 20.0749C70.5261 19.522 70.6429 18.9814 70.6429 18.4286C70.6429 16.7331 70.434 15.093 70.1453 13.4774L86 6.24114Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_384_2139",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_384_2139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_384_2139",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.bd6374e8d17ad67520fa4a22e589a735.svg";
export { ForwardRef as ReactComponent };